import { Route } from 'react-router-dom';
import { DashboardPage } from '../modules/dashboard/DashboardPage';
import { OperationTimesPage } from '../modules/operation-times/OperationTimesPage';
import { SettingsPage } from '../modules/settings/SettingsPage';
import { ReportsPage } from '../modules/reports/ReportsPage';
import { AuditPage } from '../modules/audit/AuditPage';
import { ConsolidadoPage } from '../modules/consolidado/ConsolidadoPage';
import { ComingSoonPage } from '../modules/placeholder/ComingSoonPage';
import { RequireModule, RequireAdmin } from '../shared/components';

/**
 * Registro de rutas de Control Operativo. Para agregar un modulo nuevo: crear
 * su pagina en /modules y agregar UNA linea aqui + una entrada en
 * shared/config/modules.ts. Los modulos "asignables" (ver ASSIGNABLE_MODULE_IDS)
 * se protegen con <RequireModule> para que no se pueda entrar por URL directa
 * sin permiso (el backend igual rechaza esas peticiones con 403 como defensa real).
 *
 * Devuelve un Fragment de <Route> (sin <Routes> propio) para poder anidarse
 * dentro del layout de Control Operativo en el router raiz (ver App.tsx) -
 * eso es lo que le fija la aplicacion activa (AppSection).
 */
export function ControlOperativoRoutes() {
  return (
    <>
      <Route path="/control-operativo" element={<DashboardPage />} />
      <Route path="/tiempos" element={<RequireModule moduleId="operation-times"><OperationTimesPage /></RequireModule>} />
      <Route path="/reportes" element={<RequireModule moduleId="reports"><ReportsPage /></RequireModule>} />
      <Route path="/auditoria" element={<RequireModule moduleId="audit"><AuditPage /></RequireModule>} />
      <Route path="/configuracion" element={<RequireAdmin><SettingsPage /></RequireAdmin>} />
      <Route path="/consolidado" element={<RequireAdmin><ConsolidadoPage /></RequireAdmin>} />
      <Route path="/operarios" element={<RequireModule moduleId="operators"><ComingSoonPage title="Operarios" /></RequireModule>} />
      <Route path="/dashboard" element={<RequireModule moduleId="dashboard"><ComingSoonPage title="Dashboard" /></RequireModule>} />
      <Route path="/kpis" element={<RequireModule moduleId="kpis"><ComingSoonPage title="KPIs" /></RequireModule>} />
      <Route path="/ayuda" element={<ComingSoonPage title="Ayuda" />} />
    </>
  );
}
